// extracted by css-extract-rspack-plugin
export default {"paginationStyle":"src-components-PageNumber-PageNumber-module__paginationStyle-AVO_SI","page-link":"src-components-PageNumber-PageNumber-module__page-link-U64Lru","pageLink":"src-components-PageNumber-PageNumber-module__page-link-U64Lru"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"paginationStyle\":\"src-components-PageNumber-PageNumber-module__paginationStyle-AVO_SI\",\"page-link\":\"src-components-PageNumber-PageNumber-module__page-link-U64Lru\",\"pageLink\":\"src-components-PageNumber-PageNumber-module__page-link-U64Lru\"}";
        // 1791855167249
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  